import { apiSlice } from "../apiSlice";


export const cancellationMutationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    patchCancellationStatus: builder.mutation({
      query: ({ id, order_status, remarks }) => ({
        url: `cancellations/${id}`,
        method: "PATCH",
        body: {
          order_id: id,
          order_status,
          ...(remarks && { remarks }),
        },
      }),

      async onQueryStarted(
        { id, filters },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data: updatedCancellation } = await queryFulfilled;

          // 🔄 Update list cache
          dispatch(
            apiSlice.util.updateQueryData(
              "getCancellationsList",
              filters || {},
              (draft) => {
                if (draft?.entities?.[id]) {
                  Object.assign(draft.entities[id], updatedCancellation);
                }
              }
            )
          );

          // 🔄 Update single detail cache
          dispatch(
            apiSlice.util.updateQueryData(
              "getCancellationById",
              id,
              (draft) => {
                Object.assign(draft, updatedCancellation);
              }
            )
          );
        } catch (err) {
          console.error("Failed to update cancellation:", err);
        }
      },

      invalidatesTags: (result, error, { id }) => [
        { type: "cancellations", id },
        { type: "cancellations", id: "cancellationsList" },
        { type: "ProfilePaymentSummary" },
      ],
    }),
  }),
});

export const {
  usePatchCancellationStatusMutation,
} = cancellationMutationApiSlice;
